import snackbar, { ToastProps } from '../../components/snackbar';

export const toastError = (toastContent: ToastProps) => snackbar.error(toastContent);

export const toastSuccess = (toastContent: ToastProps) => snackbar.success(toastContent);

export const toastInfo = (toastContent: ToastProps) => snackbar.info(toastContent);
